export type TranslationLanguageRow = {
  code: string
  name: string
  nativeName: string
  isSupported: boolean
  totalCount: number
  translatedCount: number
  missingCount: number
  // Description coverage, tracked apart from the name. Expected is the subset
  // of objects that carry a description in some language, so it is smaller
  // than totalCount: a row that is a bare label everywhere owes no
  // description.
  descriptionExpectedCount: number
  descriptionTranslatedCount: number
  descriptionMissingCount: number
  hasStyleSection: boolean
}

export function coveragePercent(row: TranslationLanguageRow) {
  if (row.totalCount === 0) return 0
  return Math.floor((row.translatedCount / row.totalCount) * 100)
}

export function descriptionCoveragePercent(row: TranslationLanguageRow) {
  if (row.descriptionExpectedCount === 0) return 100
  return Math.floor(
    (row.descriptionTranslatedCount / row.descriptionExpectedCount) * 100,
  )
}
